import { Navigate } from "react-router-dom";
import { hasPermission, hasAnyPermission } from "../utils/permissionUtils";

// `permission` is one key, or an array meaning "any of these".
const PermissionRoute = ({ permission, children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const allowed = Array.isArray(permission)
    ? hasAnyPermission(permission)
    : hasPermission(permission);
  if (permission && !allowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PermissionRoute;